// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customSelect .MuiOutlinedInput-root {
  height: 30px;
}
.customSelect .MuiInputLabel-outlined {
  font-size: 13px !important;
  margin: -12px 0 0 0;
  color: #7d7c7c;
}
.customSelect .MuiInputLabel-outlined.MuiInputLabel-shrink {
  display: none;
}
.customSelect .MuiSelect-selectMenu.MuiSelect-outlined {
  font-size: 13px !important;
}
.customSelect .MuiSelect-outlined.MuiSelect-outlined {
  background: none !important;
}
.customSelect .MuiOutlinedInput-root {
  height: 30px !important;
}
.customSelect .MuiSelect-selectMenu.MuiSelect-outlined {
  height: 16px !important;
}
.customSelect .MuiOutlinedInput-notchedOutline {
  border: 1px solid #fff !important;
}
.customSelect svg {
  margin-right: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/custom-select.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iBAAiB;AACnB","sourcesContent":[".customSelect .MuiOutlinedInput-root {\r\n  height: 30px;\r\n}\r\n.customSelect .MuiInputLabel-outlined {\r\n  font-size: 13px !important;\r\n  margin: -12px 0 0 0;\r\n  color: #7d7c7c;\r\n}\r\n.customSelect .MuiInputLabel-outlined.MuiInputLabel-shrink {\r\n  display: none;\r\n}\r\n.customSelect .MuiSelect-selectMenu.MuiSelect-outlined {\r\n  font-size: 13px !important;\r\n}\r\n.customSelect .MuiSelect-outlined.MuiSelect-outlined {\r\n  background: none !important;\r\n}\r\n.customSelect .MuiOutlinedInput-root {\r\n  height: 30px !important;\r\n}\r\n.customSelect .MuiSelect-selectMenu.MuiSelect-outlined {\r\n  height: 16px !important;\r\n}\r\n.customSelect .MuiOutlinedInput-notchedOutline {\r\n  border: 1px solid #fff !important;\r\n}\r\n.customSelect svg {\r\n  margin-right: 6px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
